(() => {
  const root = document.querySelector('[data-waiting-list-page]');
  const form = root?.querySelector('[data-fw-form]');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const api = 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/';
  const phone = form.elements.phone;
  const search = form.querySelector('#fw-store');
  const results = form.querySelector('#fw-results');
  const searchStatus = form.querySelector('#fw-search-status');
  const selected = form.querySelector('[data-fw-selected]');
  const attribution = form.querySelector('[data-fw-attribution]');
  const error = form.querySelector('[data-fw-error]');
  const submit = form.querySelector('[type=submit]');
  const submitLabel = form.querySelector('[data-fw-submit-label]');
  const success = root.querySelector('[data-fw-success]');
  const feedbackForm = success.querySelector('[data-fw-feedback]');
  // A tab-scoped receipt keeps the return journey intact after a reload. Never
  // put phone numbers or receipts in demo URLs or shared/localStorage state.
  const resumeKey='florame-shopify3-confirmation-v1',demoKinds=['hub','customers'];
  let resumed=null;
  try{
    const value=JSON.parse(sessionStorage.getItem(resumeKey)||'null'),age=Date.now()-Number(value?.at);
    if(value?.schema===1 && age>=0 && age<86400000 && typeof value.phone==='string' && /^[+\d\s().-]{8,60}$/.test(value.phone) && /^[a-zA-Z0-9_-]{32,128}$/.test(value.receipt))resumed=value;
    else sessionStorage.removeItem(resumeKey);
  }catch{ /* Storage may be unavailable; the current page remains usable. */ }
  const feedbackToken = resumed?.receipt || window.crypto?.randomUUID?.() || (window.crypto?.getRandomValues ? [...crypto.getRandomValues(new Uint8Array(32))].map(value=>value.toString(16).padStart(2,'0')).join('') : '');
  let registeredPhone=resumed?.phone||'',feedbackAllowed=Boolean(resumed),testMode=false,sessionAt=resumed?.at||Date.now();
  let platformDone=resumed?.platformDone===true,platformSkipped=resumed?.platformSkipped===true,demoDone=resumed?.demoDone===true;
  const viewedDemos=new Set((Array.isArray(resumed?.viewedDemos)?resumed.viewedDemos:[]).filter(value=>demoKinds.includes(value)));
  const rememberConfirmation=()=>{
    if(!registeredPhone || !feedbackAllowed || testMode)return;
    try{sessionStorage.setItem(resumeKey,JSON.stringify({schema:1,at:sessionAt,phone:registeredPhone,receipt:feedbackToken,platformDone,platformSkipped,demoDone,viewedDemos:[...viewedDemos]}));}catch{}
  };
  form.noValidate = true;
  let step = 1, changingStep = false, draftTimer, revision = 0, lastDraft = '', draftPending = false;
  const clientId = window.crypto?.randomUUID?.() || `wl_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  const validPhone = () => {
    const raw = phone.value.trim();
    const value = raw.replace(/[\s().-]/g,'').replace(/^00/,'+');
    return /^[+\d\s().-]+$/.test(raw) && /^\+[1-9]\d{7,14}$/.test(value.startsWith('+') ? value : `+39${value}`);
  };
  const payload = mode => ({action:'waiting_list_2027', mode, phone:phone.value.trim(), email:form.elements.email.value.trim(), store,
    storeQuery:search.value.trim(), features:[...form.querySelectorAll('input[name=features]:checked')].map(input=>input.value),
    website:form.elements.website.value, step, clientId, revision:++revision,...(mode==='submit' && feedbackToken?{feedbackToken}:{})});
  async function saveDraft(keepalive=false) {
    clearTimeout(draftTimer);
    if (submitting || form.hidden || !validPhone()) return;
    if(draftPending && !keepalive){scheduleDraft();return;}
    const body = payload('draft');
    const key = JSON.stringify({...body,revision:0});
    if(key === lastDraft) return;
    draftPending = true;
    try {
      const response = await fetch(`${api}partnerLeadDraft`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),keepalive});
      const result = await response.json();
      if(response.ok && result.success) {lastDraft=key; form.dataset.draftSaved='true';}
    } catch {} finally {draftPending=false;}
  }
  const scheduleDraft = () => { clearTimeout(draftTimer); draftTimer=setTimeout(()=>saveDraft(),900); };
  form.addEventListener('input',scheduleDraft);
  form.addEventListener('change',scheduleDraft);
  form.addEventListener('focusout',()=>{clearTimeout(draftTimer);draftTimer=setTimeout(()=>saveDraft(),150);});
  window.addEventListener('pagehide',()=>saveDraft(true));
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')saveDraft(true);});
  async function showStep(next) {
    if(changingStep || next===step) return;
    changingStep=true;
    const card=root.querySelector('.fw-panel');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduced && card.animate) await card.animate([{transform:'perspective(1600px) rotateY(0)',opacity:1},{transform:`perspective(1600px) rotateY(${next>step?60:-60}deg)`,opacity:.15}],{duration:140,easing:'ease-in'}).finished.catch(()=>{});
    step=next;
    form.querySelectorAll('[data-fw-stage]').forEach(stage=>{stage.hidden=Number(stage.dataset.fwStage)!==step;});
    form.querySelectorAll('[data-fw-step-nav]').forEach(button=>{
      const current=Number(button.dataset.fwStepNav)===step;
      if(current)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');
      button.classList.toggle('is-complete',Number(button.dataset.fwStepNav)<step);
    });
    if(!reduced && card.animate) await card.animate([{transform:`perspective(1600px) rotateY(${next===2?-60:60}deg)`,opacity:.15},{transform:'perspective(1600px) rotateY(0)',opacity:1}],{duration:190,easing:'ease-out'}).finished.catch(()=>{});
    changingStep=false;
    if(innerWidth<900 && card.getBoundingClientRect().top<88)card.scrollIntoView({behavior:reduced?'instant':'smooth',block:'start'});
    (step===1?form.querySelector('#fw-form-title'):form.querySelector('#fw-features-title')).focus({preventScroll:true});
    scheduleDraft();
  }
  async function validateContact() {
    phone.setCustomValidity(validPhone()?'':'Inserisci un numero di telefono valido.');
    const invalid = !phone.checkValidity()?phone:!form.elements.email.checkValidity()?form.elements.email:search.value.trim()&&!store?search:null;
    if(!invalid) return true;
    await showStep(1);
    if(invalid!==phone)form.querySelector('details').open=true;
    if(invalid===search)search.setCustomValidity('Seleziona il negozio dai risultati oppure lascia vuoto il campo.');
    invalid.reportValidity(); return false;
  }
  const advance = async()=>{if(await validateContact()){saveDraft();await showStep(2);}};
  form.querySelector('[data-fw-continue]').addEventListener('click',advance);
  form.querySelector('[data-fw-back]').addEventListener('click',()=>showStep(1));
  form.querySelectorAll('[data-fw-step-nav]').forEach(button=>button.addEventListener('click',()=>Number(button.dataset.fwStepNav)===1?showStep(1):advance()));
  let store = null, timer, lookupController, searchRevision = 0, active = -1, submitting = false;
  const closeResults = () => {
    results.hidden = true;
    search.setAttribute('aria-expanded', 'false');
    search.removeAttribute('aria-activedescendant');
    active = -1;
  };
  const invalidateLookup = () => { clearTimeout(timer); lookupController?.abort(); searchRevision++; search.removeAttribute('aria-busy'); closeResults(); };
  phone.addEventListener('input', () => phone.setCustomValidity(''));
  form.addEventListener('invalid', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  }, true);
  root.querySelectorAll('a[href="#waiting-list"]').forEach(link => link.addEventListener('click', event => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const destination = root.querySelector('#waiting-list');
    destination.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    destination.focus({ preventScroll: true });
    history.replaceState(null, '', '#waiting-list');
  }));
  async function selectStore(item) {
    invalidateLookup();
    const revision = searchRevision;
    if (item.detailsPending) {
      const controller = new AbortController(); lookupController = controller;
      const timeout = setTimeout(() => controller.abort(), 15000);
      searchStatus.textContent = 'Confermiamo l’indirizzo del negozio…';
      search.setAttribute('aria-busy', 'true');
      try {
        const params = new URLSearchParams({q:`https://www.google.com/maps/search/?api=1&query_place_id=${encodeURIComponent(item.placeId)}`,limit:'1'});
        const response = await fetch(`${api}portalPartnerBusinessLookupV1?${params}`,{signal:controller.signal});
        const payload = await response.json();
        if (revision !== searchRevision) return;
        const complete = payload.results?.find(result => result.placeId === item.placeId);
        if (!response.ok || !payload.success || !complete?.formattedAddress) throw Error('details');
        item = complete;
      } catch {
        if (revision === searchRevision) searchStatus.textContent = 'Non riusciamo a confermare l’indirizzo. Seleziona di nuovo il negozio oppure lascia vuoto il campo.';
        return;
      } finally { clearTimeout(timeout); if (revision === searchRevision) search.removeAttribute('aria-busy'); }
    }
    if (revision !== searchRevision) return;
    store = { placeId: item.placeId, name: item.name, formattedAddress: item.formattedAddress };
    search.value = `${item.name}, ${item.formattedAddress}`;
    selected.querySelector('span').textContent = `${item.name} · ${item.formattedAddress}`;
    selected.hidden = false;
    attribution.hidden = false;
    searchStatus.textContent = 'Negozio selezionato.';
    search.setCustomValidity('');
    search.focus(); scheduleDraft();
  }
  form.querySelector('[data-fw-clear]').addEventListener('click', () => {
    invalidateLookup(); store = null; search.value = ''; selected.hidden = true; attribution.hidden = true;
    searchStatus.textContent = ''; search.setCustomValidity(''); search.focus(); scheduleDraft();
  });
  search.addEventListener('input', () => {
    invalidateLookup(); store = null; selected.hidden = true; attribution.hidden = true; search.setCustomValidity('');
    const query = search.value.trim();
    results.replaceChildren();
    searchStatus.textContent = query.length && query.length < 3 ? 'Scrivi almeno 3 caratteri.' : '';
    if (query.length < 3) return;
    const revision = searchRevision;
    timer = setTimeout(async () => {
      lookupController = new AbortController();
      const controller = lookupController;
      const timeout = setTimeout(() => controller.abort('timeout'), 15000);
      searchStatus.textContent = 'Cerchiamo il tuo negozio…';
      try {
        const params = new URLSearchParams({ q: query, mode: 'suggest', limit: '5' });
        const response = await fetch(`${api}portalPartnerBusinessLookupV1?${params}`, { signal: controller.signal });
        const payload = await response.json();
        if (revision !== searchRevision) return;
        if (!response.ok || !payload.success) throw Error('lookup');
        const items = (payload.results || []).filter(item => item.placeId && item.name && item.formattedAddress);
        results.replaceChildren();
        items.forEach((item, index) => {
          const li = document.createElement('li'); li.setAttribute('role', 'presentation');
          const option = document.createElement('button');
          option.type = 'button'; option.id = `fw-result-${index}`; option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false'); option.tabIndex = -1;
          const name = document.createElement('strong'); name.textContent = item.name;
          const address = document.createElement('small'); address.textContent = item.formattedAddress;
          option.append(name, address); option.addEventListener('click', () => selectStore(item));
          li.append(option); results.append(li);
        });
        searchStatus.textContent = items.length ? 'Seleziona il tuo negozio.' : 'Nessun negozio trovato. Prova con nome, via e città; puoi anche lasciare questo campo vuoto.';
        results.hidden = !items.length; attribution.hidden = !items.length;
        search.setAttribute('aria-expanded', String(!!items.length));
      } catch (failure) {
        if (revision !== searchRevision) return;
        searchStatus.textContent = 'Ricerca momentaneamente non disponibile. Riprova oppure lascia vuoto il campo: puoi iscriverti con il solo telefono.';
        closeResults();
      } finally { clearTimeout(timeout); }
    }, 500);
  });
  search.addEventListener('keydown', event => {
    const options = [...results.querySelectorAll('[role=option]')];
    if (event.key === 'Escape') { invalidateLookup(); return; }
    if (event.key === 'Enter' && !results.hidden && options.length) {
      event.preventDefault(); options[Math.max(active, 0)].click(); return;
    }
    if (!['ArrowDown', 'ArrowUp'].includes(event.key) || !options.length) return;
    event.preventDefault(); results.hidden = false; search.setAttribute('aria-expanded', 'true');
    active = active < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
    options.forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
    search.setAttribute('aria-activedescendant', options[active].id);
    options[active].scrollIntoView({ block: 'nearest' });
  });
  document.addEventListener('pointerdown', event => { if (!event.target.closest('.fw-search')) closeResults(); });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting) return;
    if(step===1){await advance();return;}
    if(!await validateContact())return;
    clearTimeout(draftTimer);
    error.hidden = true; submitting = true; submit.disabled = true; form.setAttribute('aria-busy', 'true');
    submitLabel.textContent = 'Invio in corso…';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`${api}partnerLeadDraft`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
        body: JSON.stringify(payload('submit')),
      });
      const result = await response.json();
      if (!response.ok || result.success !== true || result.registered !== true) throw Error(response.status === 400 ? result.error : 'Invio non riuscito. Riprova tra poco: i tuoi dati restano nel modulo.');
      registeredPhone=phone.value.trim();
      feedbackAllowed=result.feedbackAllowed===true;testMode=result.testMode===true;sessionAt=Date.now();
      rememberConfirmation();showConfirmation();
      if(root.querySelector('.fw-panel').getBoundingClientRect().top<88)root.querySelector('.fw-panel').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    } catch (failure) {
      error.textContent = failure.name === 'AbortError' ? 'La risposta sta impiegando troppo tempo. Riprova: se la richiesta è già arrivata, non verrà duplicata.' : (failure.message === 'Failed to fetch' ? 'Controlla la connessione e riprova. I tuoi dati restano nel modulo.' : failure.message);
      error.hidden = false;
    } finally {
      clearTimeout(timeout); submitting = false; submit.disabled = false; form.removeAttribute('aria-busy'); submitLabel.textContent = 'Iscriviti alla lista d’attesa';
    }
  });
  const feedbackSubmit=feedbackForm.querySelector('[type=submit]');
  const feedbackError=feedbackForm.querySelector('[data-fw-feedback-error]');
  let feedbackSending=false;
  const selectedRating=()=>{const value=feedbackForm.querySelector('input[name=rating]:checked')?.value;return value?Number(value):null;};
  const selectedChannels=()=>[...feedbackForm.querySelectorAll('input[name=salesChannels]:checked')].map(input=>input.value);
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
  // Analytic damped springs preserve position AND velocity when interrupted.
  // WAAPI samples run on the compositor; no reflow/restarting CSS animations.
  const motions=new Map(),particles=new Set();
  const sampleSpring=(motion,t)=>{
    const damping=motion.c/2,frequency=Math.sqrt(motion.k-damping*damping);
    const delta=motion.from-motion.target,b=(motion.velocity+damping*delta)/frequency;
    const decay=Math.exp(-damping*t),cos=Math.cos(frequency*t),sin=Math.sin(frequency*t);
    const offset=delta*cos+b*sin;
    return {position:motion.target+decay*offset,velocity:decay*(-damping*offset+frequency*(-delta*sin+b*cos))};
  };
  const springTo=(element,target,{kick=0,k=340,c=20,transform}={})=>{
    if(!element || reducedMotion.matches || !element.animate)return;
    const previous=motions.get(element),now=performance.now();
    const current=previous?sampleSpring(previous,Math.max(0,(now-previous.startedAt)/1000)):{position:0,velocity:0};
    previous?.animation.cancel();
    const motion={from:current.position,target,velocity:current.velocity+kick,k,c,startedAt:now};
    const frames=Array.from({length:61},(_,index)=>({transform:transform(sampleSpring(motion,index/60*.95).position),offset:index/60}));
    frames[60].transform=transform(target);
    const animation=element.animate(frames,{duration:950,easing:'linear',fill:'both'});
    motion.animation=animation;motions.set(element,motion);
    animation.onfinish=()=>{if(motions.get(element)!==motion)return;element.style.transform=transform(target);motions.delete(element);animation.cancel();};
  };
  const burst=(choice,selector,frames,delay=0)=>{
    const template=choice.querySelector(selector);if(!template || reducedMotion.matches || !template.animate)return;
    if(particles.size>=12){const oldest=particles.values().next().value;oldest.animation.cancel();oldest.element.remove();particles.delete(oldest);}
    const element=template.cloneNode(true);element.setAttribute('data-fw-particle','');template.parentNode.append(element);
    const animation=element.animate(frames,{duration:1000,delay,easing:'cubic-bezier(.2,.65,.25,1)'});
    const particle={element,animation};particles.add(particle);
    const clean=()=>{element.remove();particles.delete(particle);};animation.onfinish=clean;animation.oncancel=clean;
  };
  const clearMotion=()=>{for(const [element,motion] of motions){motion.animation.cancel();element.style.removeProperty('transform');}motions.clear();for(const particle of particles){particle.animation.cancel();particle.element.remove();}particles.clear();};
  reducedMotion.addEventListener?.('change',()=>{if(reducedMotion.matches)clearMotion();});
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')clearMotion();});
  feedbackForm.querySelectorAll('.fw-mood-choice,.fw-channel-choice').forEach(choice=>{
    const mood=Number(choice.dataset.mood)||0;
    const input=choice.querySelector('input');
    const body=choice.querySelector(mood?'.fw-mochi-body':'.fw-channel-art>svg');
    const shape=position=>{const q=9*Math.tanh(position/9);return `translateY(${q.toFixed(3)}px) rotate(${(q*(mood===1?.15:mood===2?-.35:.3)).toFixed(3)}deg) scale(${(1+q*.012).toFixed(4)},${(1-q*.012).toFixed(4)})`;};
    let bounds;
    const react=()=>{
      if(reducedMotion.matches)return;
      springTo(body,0,{kick:mood===5?-190:mood===1?-90:mood?-135:-100,transform:shape});
      if(mood===1)for(const side of ['left','right']){
        const direction=side==='left'?-1:1,start=side==='left'?34:54;
        burst(choice,`.fw-mochi-puff-${side}`,[{opacity:0,transform:`translate(${start}px,48px) scale(.2)`,offset:0},{opacity:.95,transform:`translate(${start+direction*7}px,55px) scale(.65)`,offset:.2},{opacity:.8,transform:`translate(${start+direction*16}px,58px) scale(.9)`,offset:.55},{opacity:0,transform:`translate(${start+direction*23}px,54px) scale(1.1)`,offset:1}],side==='left'?0:55);
      }
      if(mood===5)for(const side of ['left','right']){
        const x=side==='left'?18:70,direction=side==='left'?-1:1;
        burst(choice,`.fw-mochi-heart-${side}`,[{opacity:0,transform:`translate(${x}px,31px) scale(.2) rotate(0deg)`,offset:0},{opacity:1,transform:`translate(${x+direction*2}px,21px) scale(.65) rotate(${direction*12}deg)`,offset:.25},{opacity:.9,transform:`translate(${x+direction*4}px,13px) scale(.7) rotate(${direction*18}deg)`,offset:.65},{opacity:0,transform:`translate(${x+direction*6}px,6px) scale(.5) rotate(${direction*22}deg)`,offset:1}],side==='left'?40:140);
      }
      if(mood===2){const tear=choice.querySelector('.fw-mochi-tear');springTo(tear,0,{kick:90,k:230,c:19,transform:q=>`translateY(${q.toFixed(3)}px) scale(${(1-q*.02).toFixed(4)},${(1+q*.025).toFixed(4)})`});}
      if(mood===4)burst(choice,'.fw-mochi-sparkle',[{opacity:0,transform:'scale(.7)',offset:0},{opacity:1,transform:'scale(1)',offset:.3},{opacity:0,transform:'scale(1.15)',offset:1}]);
    };
    input.addEventListener('pointerdown',()=>springTo(body,3,{k:620,c:32,transform:shape}));
    input.addEventListener('pointerup',()=>springTo(body,0,{transform:shape}));
    input.addEventListener('pointercancel',()=>springTo(body,0,{transform:shape}));
    input.addEventListener('blur',()=>springTo(body,0,{transform:shape}));
    input.addEventListener('click',react);
    choice.addEventListener('pointerenter',()=>{bounds=choice.getBoundingClientRect();});
    choice.addEventListener('pointermove',event=>{
      if(reducedMotion.matches || event.pointerType!=='mouse' || !mood || !bounds)return;
      choice.style.setProperty('--gaze-x',`${((event.clientX-bounds.left)/bounds.width-.5)*1.5}px`);
      choice.style.setProperty('--gaze-y',`${((event.clientY-bounds.top)/bounds.height-.5)*1}px`);
    });
    choice.addEventListener('pointerleave',()=>{choice.style.removeProperty('--gaze-x');choice.style.removeProperty('--gaze-y');springTo(body,0,{transform:shape});});
  });
  const syncFeedback=()=>{
    const rating=selectedRating();
    feedbackForm.querySelector('[data-fw-problems]').hidden=![1,2].includes(rating);
    feedbackSubmit.disabled=feedbackSending || !(rating || selectedChannels().length || feedbackForm.elements.expectations.value.trim());
  };
  feedbackForm.addEventListener('change',syncFeedback);feedbackForm.addEventListener('input',syncFeedback);
  feedbackForm.querySelector('[data-fw-feedback-skip]').addEventListener('click',()=>{platformSkipped=true;rememberConfirmation();feedbackForm.hidden=true;success.querySelector('h3').focus({preventScroll:true});});
  feedbackForm.addEventListener('submit',async event=>{
    event.preventDefault();if(feedbackSending || feedbackSubmit.disabled)return;
    feedbackSending=true;feedbackSubmit.disabled=true;feedbackForm.setAttribute('aria-busy','true');feedbackError.hidden=true;
    const label=feedbackSubmit.querySelector('span');label.textContent='Invio in corso…';
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),20000);
    try{
      const rating=selectedRating();
      const response=await fetch(`${api}partnerLeadDraft`,{method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({action:'waiting_list_feedback_2027',phone:registeredPhone,feedbackToken,rating,salesChannels:selectedChannels(),problems:[1,2].includes(rating)?feedbackForm.elements.problems.value.trim():'',expectations:feedbackForm.elements.expectations.value.trim()})});
      const result=await response.json();
      if(!response.ok || result.feedbackSaved!==true)throw Error(response.status===400||response.status===403?result.error:'Non siamo riusciti a salvare il parere. Riprova: la tua iscrizione è già confermata.');
      platformDone=true;platformSkipped=false;rememberConfirmation();feedbackForm.hidden=true;const thanks=success.querySelector('[data-fw-feedback-thanks]');thanks.hidden=false;thanks.focus({preventScroll:true});
    }catch(failure){feedbackError.textContent=failure.name==='AbortError'?'La risposta sta impiegando troppo tempo. Puoi riprovare: la tua iscrizione è già confermata.':failure.message==='Failed to fetch'?'Controlla la connessione e riprova. La tua iscrizione è già confermata.':failure.message;feedbackError.hidden=false;}
    finally{clearTimeout(timeout);feedbackSending=false;feedbackForm.removeAttribute('aria-busy');label.textContent='Invia il tuo parere';syncFeedback();}
  });
  const demoReview=success.querySelector('[data-fw-demo-review]'),demoForm=success.querySelector('[data-fw-demo-form]');
  const demoSubmit=demoForm.querySelector('[type=submit]'),demoError=demoForm.querySelector('[data-fw-demo-error]');
  let demoSending=false;
  const demoRating=()=>Number(demoForm.querySelector('[name=demoRating]:checked')?.value)||0;
  const syncDemoReview=(announce=false)=>{
    const wasHidden=demoReview.hidden;
    demoReview.hidden=!feedbackAllowed || demoDone || !viewedDemos.size;
    success.querySelector('[data-fw-demo-thanks]').hidden=!demoDone;
    const context=viewedDemos.size===2?'Hub e pagina clienti':viewedDemos.has('hub')?'Demo Hub':'Pagina clienti';
    demoReview.querySelector('[data-fw-demo-context]').textContent=`${context} · Facoltativo`;
    if(announce && wasHidden && !demoReview.hidden){
      demoReview.classList.add('is-new');
      success.querySelector('[data-fw-demo-announcement]').textContent='Hai esplorato florame.ai? Ora puoi lasciare una valutazione facoltativa.';
    }
    demoSubmit.disabled=demoSending || !demoRating() || !viewedDemos.size;
  };
  function showConfirmation(restore=false){
    form.hidden=true;success.hidden=false;feedbackForm.hidden=!feedbackAllowed || platformDone || platformSkipped;
    success.querySelector('[data-fw-feedback-thanks]').hidden=!platformDone;
    root.querySelector('#fw-title').innerHTML='Sei nella<br>lista d’attesa.';
    syncDemoReview();
    if(!restore)success.querySelector('h3').focus({preventScroll:true});
  }
  // Make the closed review available as the link opens. This also works in
  // browsers that keep target=_blank in the background or suppress focus events.
  // Opening a link records its destination, never claims the demo was completed.
  success.querySelectorAll('[data-fw-demo]').forEach(link=>{
    const opened=event=>{
      if(event.defaultPrevented || (event.type==='auxclick' && event.button!==1) || !demoKinds.includes(link.dataset.fwDemo))return;
      viewedDemos.add(link.dataset.fwDemo);rememberConfirmation();syncDemoReview(true);
    };
    link.addEventListener('click',opened);link.addEventListener('auxclick',opened);
  });
  demoForm.addEventListener('change',()=>{
    const rating=demoRating(),labels=['','Da migliorare','Sotto le aspettative','Buona base','Molto buona','Ottima'];
    demoForm.querySelectorAll('.fw-star-choice').forEach(choice=>choice.classList.toggle('is-filled',Number(choice.querySelector('input').value)<=rating));
    demoForm.querySelector('[data-fw-star-label]').textContent=rating?`${rating} su 5 · ${labels[rating]}`:'Tocca una stella';
    syncDemoReview();
  });
  demoForm.addEventListener('submit',async event=>{
    event.preventDefault();if(demoSending || demoSubmit.disabled)return;
    demoSending=true;demoSubmit.disabled=true;demoForm.setAttribute('aria-busy','true');demoError.hidden=true;
    demoForm.querySelectorAll('input,textarea').forEach(input=>{input.disabled=true;});
    const label=demoSubmit.querySelector('span');label.textContent='Invio in corso…';
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),20000);
    try{
      const response=await fetch(`${api}partnerLeadDraft`,{method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({action:'waiting_list_feedback_2027',feedbackKind:'demo',phone:registeredPhone,feedbackToken,rating:demoRating(),viewedDemos:[...viewedDemos],comment:demoForm.elements.comment.value.trim()})});
      const result=await response.json();
      if(!response.ok || result.feedbackSaved!==true || result.feedbackKind!=='demo')throw Error([400,403].includes(response.status)?result.error:'Non siamo riusciti a salvare la valutazione. Riprova: la tua iscrizione è confermata.');
      demoDone=true;rememberConfirmation();syncDemoReview();success.querySelector('[data-fw-demo-thanks]').focus({preventScroll:true});
    }catch(failure){demoError.textContent=failure.name==='AbortError'?'La risposta sta impiegando troppo tempo. Puoi riprovare senza duplicare la valutazione.':failure.message==='Failed to fetch'?'Controlla la connessione e riprova. La tua valutazione resta nel modulo.':failure.message;demoError.hidden=false;}
    finally{clearTimeout(timeout);demoSending=false;demoForm.removeAttribute('aria-busy');demoForm.querySelectorAll('input,textarea').forEach(input=>{input.disabled=false;});label.textContent='Invia la valutazione';syncDemoReview();}
  });
  if(resumed)showConfirmation(true);
  const dialog = root.querySelector('[data-fw-dialog]');
  const player = dialog.querySelector('video');
  let trigger;
  const media = {
    voice: { title: 'Aggiornamento con AI Vocale', description: 'Aggiorna i fiori disponibili parlando con l’AI.', file: 'voice-feature-v4.mp4', poster: 'voice-loop-start-v1.webp' },
    camera: { title: 'Telecamera Intelligente', description: 'La telecamera aiuta a rilevare i fiori disponibili.', file: 'camera-feature-v5.mp4', poster: 'camera-loop-start-v1.webp' },
  };
  root.querySelectorAll('[data-fw-video]').forEach(button => button.addEventListener('click', () => {
    const item = media[button.dataset.fwVideo]; trigger = button;
    dialog.querySelector('h3').textContent = item.title;
    dialog.querySelector('#fw-video-description').textContent = item.description;
    dialog.querySelector('[data-fw-video-error]').hidden = true;
    player.poster = `https://hub.florame.ai/availability/promo/${item.poster}`;
    player.src = `https://hub.florame.ai/availability/promo/${item.file}`;
    player.controls = false; player.muted = true; player.loop = true; dialog.querySelector('[data-fw-pause]').textContent='Riproduci'; dialog.showModal(); document.documentElement.classList.add('fw-modal-open');
    player.load();
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) player.play().catch(() => {});
  }));
  const playButton=dialog.querySelector('[data-fw-pause]');
  const syncPlayback=()=>{playButton.textContent=player.paused?'Riproduci':'Pausa';playButton.setAttribute('aria-label',player.paused?'Riproduci il video':'Metti in pausa il video');};
  player.addEventListener('playing',syncPlayback);player.addEventListener('pause',syncPlayback);
  playButton.addEventListener('click',()=>{if(player.paused)player.play().catch(()=>{});else player.pause();});
  dialog.querySelector('[data-fw-fullscreen]').addEventListener('click',()=>{if(player.requestFullscreen)player.requestFullscreen().catch(()=>{});else player.webkitEnterFullscreen?.();});
  player.addEventListener('error', () => { dialog.querySelector('[data-fw-video-error]').hidden = false; });
  dialog.querySelector('[data-fw-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    player.pause(); player.removeAttribute('src'); player.load();
    document.documentElement.classList.remove('fw-modal-open'); trigger?.focus();
  });
})();
